
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchExportData } from "../../actions/sector/sectorActions";

const normalize = (str) =>
  str?.toLowerCase().replace(/[^a-z0-9]/gi, "").trim();

const GlobalExports = ({ categories = [], onProductSelect = () => { } }) => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { loading, data: exportData, error } = useSelector(
    (state) =>
      state.exportDataReducer || {
        loading: false,
        data: null,
        error: null,
      }
  );

  useEffect(() => {
    dispatch(fetchExportData());
  }, [dispatch]);

  const displayData = useMemo(() => exportData || null, [exportData]);

  // Prepare all products for table
  // const allProductsData = useMemo(() => {
  //   if (!displayData) return [];

  //   const useCategories = categories.length
  //     ? categories
  //     : Object.keys(displayData).filter((key) => key !== "_summary");

  //   const entriesArray = Object.entries(displayData)
  //     .filter(([key]) => key !== "_summary")
  //     .map(([key, data]) => ({ key, data }));

  //   const productMap = new Map();

  //   useCategories.forEach((cat) => {
  //     const normalizedCat = normalize(cat);
  //     const matchedEntry = entriesArray.find(
  //       ({ key }) => normalize(key) === normalizedCat
  //     );

  //     if (!matchedEntry) return;

  //     const { data: categoryData } = matchedEntry;

  //     Object.entries(categoryData).forEach(([commodity, commodityData]) => {
  //       if (commodity === "_summary") return;

  //       let totalQuantity = 0;
  //       let totalValue = 0;

  //       Object.entries(commodityData).forEach(([country, values]) => {
  //         if (country === "_summary") return;
  //         totalQuantity += parseFloat(values?.quantity || 0);
  //         totalValue += parseFloat(values?.value_usd_million || 0);
  //       });

  //       const normalizedProduct = normalize(commodity);

  //       if (
  //         normalizedProduct.includes("rice") &&
  //         normalizedProduct.includes("basmoti")
  //       ) {
  //         const key = "RICE BASMOTI";
  //         if (productMap.has(key)) {
  //           const existing = productMap.get(key);
  //           productMap.set(key, {
  //             product: key,
  //             quantity: existing.quantity + totalQuantity,
  //             value: existing.value + totalValue,
  //           });
  //         } else {
  //           productMap.set(key, {
  //             product: key,
  //             quantity: totalQuantity,
  //             value: totalValue,
  //           });
  //         }
  //       } else {
  //         productMap.set(commodity, {
  //           product: commodity,
  //           quantity: totalQuantity,
  //           value: totalValue,
  //         });
  //       }
  //     });
  //   });

  //   return Array.from(productMap.values()).sort((a, b) => b.value - a.value);
  // }, [displayData, categories]);

  // Prepare all products for table
const allProductsData = useMemo(() => {
  if (!displayData) return [];

  // console.log("Display Data Structure:", displayData);

  const productMap = new Map();

  // Iterate through all top-level categories
  Object.entries(displayData).forEach(([categoryName, categoryData]) => {
    if (categoryName === "_summary" || !categoryData || typeof categoryData !== 'object') return;

    // console.log(`Processing category: ${categoryName}`, categoryData);

    // Iterate through each product in the category
    Object.entries(categoryData).forEach(([productName, productData]) => {
      if (productName === "_summary" || !productData || typeof productData !== 'object') return;

      let totalQuantity = 0;
      let totalValue = 0;

      // Sum up all countries for this product
      Object.entries(productData).forEach(([key, values]) => {
        if (key === "_summary" || !values || typeof values !== 'object') return;
        
        totalQuantity += parseFloat(values?.quantity || 0);
        totalValue += parseFloat(values?.value_usd_million || 0);
      });

      // console.log(`Product: ${productName}, Quantity: ${totalQuantity}, Value: ${totalValue}`);

      // Handle special case for rice basmati
      const normalizedProduct = normalize(productName);
      const finalProductName = 
        (normalizedProduct.includes("rice") && normalizedProduct.includes("basmoti")) 
          ? "RICE BASMOTI" 
          : productName;

      if (productMap.has(finalProductName)) {
        const existing = productMap.get(finalProductName);
        productMap.set(finalProductName, {
          product: finalProductName,
          quantity: existing.quantity + totalQuantity,
          value: existing.value + totalValue,
        });
      } else {
        productMap.set(finalProductName, {
          product: finalProductName,
          quantity: totalQuantity,
          value: totalValue,
        });
      }
    });
  });

  const result = Array.from(productMap.values()).sort((a, b) => b.value - a.value);
  // console.log("Final products data:", result);
  return result;
}, [displayData, categories]);


  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!displayData) return <div>No data available</div>;
  if (!allProductsData.length) return <div>No products found</div>;

  const handleRowClick = (product) => {
    setSelectedProduct(product);
    onProductSelect(product);
  };

  return (
    <>
      <h3
        style={{
          fontWeight: "600",
          fontSize: "14px",
          marginBottom: "8px",
        }}
      >
        GLOBAL EXPORTS
      </h3>

      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
          marginBottom: "32px",
          maxHeight: "450px",

        }}
      >

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr",
            fontWeight: "600",
            fontSize: "13px",
            padding: "10px 0",
            borderBottom: "1px solid #ccc",
            backgroundColor: "#fafafa",
            position: "sticky",
            top: 0,
            zIndex: 5,
          }}
        >
          <div style={{ paddingLeft: "12px" }}>Product</div>
          <div style={{ textAlign: "center" }}>Quantity (Ton)</div>
          <div style={{ textAlign: "right", paddingRight: "12px" }}>
            Value (US $ MM)
          </div>
        </div>

        {/* Scrollable body */}
        {allProductsData.map((item, idx) => (
          <div
            key={idx}
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr 1fr",
              padding: "12px 0",
              fontSize: "13px",
              borderBottom: "1px solid #f1f1f1",
              cursor: "pointer",
              backgroundColor: "#F2F7F7",
              color: "#000",
              border:
                selectedProduct === item.product ? "2px solid #30D5C8" : "none",
              borderRadius: selectedProduct === item.product ? "4px" : "0",
            }}
            onClick={() => handleRowClick(item.product)}
          >
            <div style={{ padding: "8px 12px" }}>{item.product}</div>
            <div
              style={{
                textAlign: "center",
                padding: "8px 12px",
                borderLeft: "1px solid #e0e0e0",
              }}
            >
              {item.quantity?.toLocaleString() || "-"}
            </div>
            <div
              style={{
                textAlign: "right",
                padding: "8px 12px",
                borderLeft: "1px solid #e0e0e0",
              }}
            >
              {item.value?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        ))}
      </div>
    </>
  );

};

export default GlobalExports;


// import React, { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchExportData } from "../../actions/sector/sectorActions";

// const normalize = (str) =>
//   str?.toLowerCase().replace(/[^a-z0-9]/gi, "").trim();

// const GlobalExports = ({ categories = [], onProductSelect = () => {} }) => {
//   const dispatch = useDispatch();
//   const [selectedProduct, setSelectedProduct] = useState(null);

//   const { loading, data: exportData, error } = useSelector(
//     (state) =>
//       state.exportDataReducer || {
//         loading: false,
//         data: null,
//         error: null,
//       }
//   );

//   useEffect(() => {
//     dispatch(fetchExportData());
//   }, [dispatch]);

//   // Prepare all products for table
//   const allProductsData = useMemo(() => {
//     if (!exportData) return [];

//     // Determine which categories to use
//     const usedCategories =
//       categories.length > 0 ? categories : Object.keys(exportData);

//     const productMap = new Map();

//     usedCategories.forEach((categoryName) => {
//       const categoryData = exportData[categoryName];
//       if (!categoryData || typeof categoryData !== "object") return;

//       Object.entries(categoryData).forEach(([productName, productData]) => {
//         if (!productData || typeof productData !== "object") return;
//         if (productName === "_summary") return;

//         let totalQuantity = 0;
//         let totalValue = 0;

//         Object.entries(productData).forEach(([country, values]) => {
//           if (!values || country === "_summary") return;
//           totalQuantity += parseFloat(values.quantity || 0);
//           totalValue += parseFloat(values.value_usd_million || 0);
//         });

//         // Handle special case for RICE BASMOTI
//         const normalizedProduct = normalize(productName);
//         const finalProductName =
//           normalizedProduct.includes("rice") && normalizedProduct.includes("basmoti")
//             ? "RICE BASMOTI"
//             : productName;

//         if (productMap.has(finalProductName)) {
//           const existing = productMap.get(finalProductName);
//           productMap.set(finalProductName, {
//             product: finalProductName,
//             quantity: existing.quantity + totalQuantity,
//             value: existing.value + totalValue,
//           });
//         } else {
//           productMap.set(finalProductName, {
//             product: finalProductName,
//             quantity: totalQuantity,
//             value: totalValue,
//           });
//         }
//       });
//     });

//     return Array.from(productMap.values()).sort((a, b) => b.value - a.value);
//   }, [exportData, categories]);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>Error: {error.message || "Something went wrong"}</div>;
//   if (!exportData) return <div>No data available</div>;
//   if (!allProductsData.length) return <div>No products found</div>;

//   const handleRowClick = (product) => {
//     setSelectedProduct(product);
//     onProductSelect(product);
//   };

//   return (
//     <>
//       <h3
//         style={{
//           fontWeight: "600",
//           fontSize: "14px",
//           marginBottom: "8px",
//         }}
//       >
//         GLOBAL EXPORTS
//       </h3>

//       <div
//         style={{
//           border: "1px solid #e0e0e0",
//           borderRadius: "8px",
//           backgroundColor: "#fff",
//           boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
//           marginBottom: "32px",
//           maxHeight: "450px",
//           overflowY: "auto",
//         }}
//       >
//         {/* Table header */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "2fr 1fr 1fr",
//             fontWeight: "600",
//             fontSize: "13px",
//             padding: "10px 0",
//             borderBottom: "1px solid #ccc",
//             backgroundColor: "#fafafa",
//             position: "sticky",
//             top: 0,
//             zIndex: 5,
//           }}
//         >
//           <div style={{ paddingLeft: "12px" }}>Product</div>
//           <div style={{ textAlign: "center" }}>Quantity (Ton)</div>
//           <div style={{ textAlign: "right", paddingRight: "12px" }}>
//             Value (US $ MM)
//           </div>
//         </div>

//         {/* Table body */}
//         {allProductsData.map((item, idx) => (
//           <div
//             key={idx}
//             style={{
//               display: "grid",
//               gridTemplateColumns: "2fr 1fr 1fr",
//               padding: "12px 0",
//               fontSize: "13px",
//               borderBottom: "1px solid #f1f1f1",
//               cursor: "pointer",
//               backgroundColor: "#F2F7F7",
//               color: "#000",
//               border:
//                 selectedProduct === item.product ? "2px solid #30D5C8" : "none",
//               borderRadius: selectedProduct === item.product ? "4px" : "0",
//             }}
//             onClick={() => handleRowClick(item.product)}
//           >
//             <div style={{ padding: "8px 12px" }}>{item.product}</div>
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: "8px 12px",
//                 borderLeft: "1px solid #e0e0e0",
//               }}
//             >
//               {item.quantity?.toLocaleString() || "0"}
//             </div>
//             <div
//               style={{
//                 textAlign: "right",
//                 padding: "8px 12px",
//                 borderLeft: "1px solid #e0e0e0",
//               }}
//             >
//               {item.value?.toLocaleString(undefined, {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//               })}
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default GlobalExports;
